import { useState } from 'react';
import { Icon } from './Icon';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ANALYTICS_EVENTS, type Locale } from '@neke/core';
import { useSession } from '../store/session';
import { track } from '../analytics';

/** Мобильная шапка: логотип, переключатель языка и бургер. */
export function Header() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { user, locale, setLocale, logout } = useSession();
  const navigate = useNavigate();

  const toggleLocale = () => {
    const next = (locale === 'ru' ? 'kk' : 'ru') as Locale;
    setLocale(next);
    void track(ANALYTICS_EVENTS.localeChanged, { locale: next, from: locale });
  };

  const close = () => setOpen(false);

  return (
    <>
      <header className="header">
        <Link to="/" className="logo" onClick={close}>
          <img
            src="/brand/logo-mark.png"
            srcSet="/brand/logo-mark@1x.png 1x, /brand/logo-mark.png 2x"
            alt=""
            width={34}
            height={34}
          />
          <span>
            <span className="logo-word">NEKE</span>
            <span className="logo-sub">
              test.kz
            </span>
          </span>
        </Link>

        {/* Показываем язык, на котором человек сейчас находится, а не тот, куда переключится. */}
        <button
          className="icon-btn lang-btn"
          onClick={toggleLocale}
          aria-label="Тіл / Язык"
          title={locale === 'ru' ? 'Ауысу: қазақша' : 'Переключить: по-русски'}
        >
          {locale === 'ru' ? 'РУС' : 'ҚАЗ'}
          <span aria-hidden className="lang-caret">
            ⌄
          </span>
        </button>

        <button
          className="icon-btn"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? t('nav.close') : t('nav.menu')}
          aria-expanded={open}
        >
          <Icon name={open ? 'close' : 'menu'} size={19} />
        </button>
      </header>

      {open && (
        <nav className="menu">
          <button className="icon-btn menu-close" onClick={close} aria-label={t('nav.close')}>
            <Icon name="close" size={19} />
          </button>
          <Link to="/about" onClick={close}>
            {t('nav.about')}
          </Link>
          <Link to="/how" onClick={close}>
            {t('nav.how')}
          </Link>
          <Link to="/spheres" onClick={close}>
            {t('nav.spheres')}
          </Link>
          <Link to="/blog" onClick={close}>
            {t('nav.blog')}
          </Link>

          {user ? (
            <>
              <Link to="/result" onClick={close}>
                {t('nav.profile')}
              </Link>
              <Link to="/matches" onClick={close}>
                {t('nav.matches')}
              </Link>
              {/* Только ADMIN: сервер пускает в /api/admin по списку почт,
                  MATCHMAKER упрётся в 403 — незачем показывать ему ссылку. */}
              {user.role === 'ADMIN' && (
                <Link to="/admin" onClick={close}>
                  {t('nav.admin')}
                </Link>
              )}
              <button
                className="btn btn-ghost menu-action"
                onClick={() => {
                  void logout();
                  close();
                  navigate('/');
                }}
              >
                {t('auth.logout')}
              </button>
            </>
          ) : (
            <Link to="/login" onClick={close}>
              {t('nav.login')}
            </Link>
          )}

          <Link
            to="/test"
            className="btn btn-primary menu-action"
            onClick={close}
          >
            {t('nav.start')}
          </Link>
        </nav>
      )}
    </>
  );
}
